import { createClient } from '@supabase/supabase-js';
import type { AssignmentVerdict } from '../types/models';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface LeaderboardRow {
  id: string;
  created_at: string;
  score: number;
  time_spent: number;
  decisions: AssignmentVerdict[];
  nickname: string;
}

// Zapisz wynik automatycznie w tle
export const savePlayerScore = async (
  score: number,
  timeSpent: number,
  decisions: AssignmentVerdict[]
): Promise<LeaderboardRow | null> => {
  const { data, error } = await supabase
    .from('leaderboard')
    .insert([{ score, time_spent: timeSpent, decisions }])
    .select()
    .single();

  if (error) {
    console.error('Supabase save error:', error);
    return null;
  }
  return data as LeaderboardRow;
};

// Pobierz TOP 6 z sortowaniem po score (desc) i time_spent (asc)
export const fetchTopScores = async (): Promise<LeaderboardRow[]> => {
  const { data, error } = await supabase
    .from('leaderboard')
    .select('*')
    .order('score', { ascending: false })
    .order('time_spent', { ascending: true })
    .limit(6);

  if (error) {
    console.error('Supabase fetch error:', error);
    return [];
  }
  return data as LeaderboardRow[];
};

// Zaktualizuj nick gracza
export const updatePlayerNickname = async (
  id: string,
  nickname: string
): Promise<boolean> => {
  const { error } = await supabase
    .from('leaderboard')
    .update({ nickname })
    .eq('id', id);

  if (error) {
    console.error('Supabase update nickname error:', error);
    return false;
  }
  return true;
};
